// openEHR AM model — BMM package org.openehr.am.aom2.persistence.constraint_model
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import * as openehr_base from "../../../base/mod.ts";

/**
 * Archetype equivalent to LOCATABLE class in openEHR Common reference model. Defines common constraints for any inheritor of LOCATABLE in any reference model.
 */
export abstract class P_ARCHETYPE_CONSTRAINT {
}

/**
 * Abstract model of constraint on any kind of object node.
 */
export abstract class P_C_OBJECT extends P_ARCHETYPE_CONSTRAINT {
  /**
   * Internal storage for rm_type_name
   * @protected
   */
  protected _rm_type_name?: openehr_base.String;

  /**
   * Reference model type that this node corresponds to.
   */
  get rm_type_name(): string | undefined {
    return this._rm_type_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for rm_type_name.
   * Use this to access openehr_base.String methods.
   */
  get $rm_type_name(): openehr_base.String | undefined {
    return this._rm_type_name;
  }

  /**
   * Sets rm_type_name from either a primitive value or openehr_base.String wrapper.
   */
  set rm_type_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._rm_type_name = undefined;
    } else if (typeof val === "string") {
      this._rm_type_name = openehr_base.String.from(val);
    } else {
      this._rm_type_name = val;
    }
  }

  /**
   * Internal storage for occurrences
   * @protected
   */
  protected _occurrences?: openehr_base.String;

  /**
   * Occurrences of this object node in the data, under the owning attribute. Upper limit can only be greater than 1 if owning attribute has a cardinality of more than 1.
   */
  get occurrences(): string | undefined {
    return this._occurrences?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for occurrences.
   * Use this to access openehr_base.String methods.
   */
  get $occurrences(): openehr_base.String | undefined {
    return this._occurrences;
  }

  /**
   * Sets occurrences from either a primitive value or openehr_base.String wrapper.
   */
  set occurrences(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._occurrences = undefined;
    } else if (typeof val === "string") {
      this._occurrences = openehr_base.String.from(val);
    } else {
      this._occurrences = val;
    }
  }

  /**
   * Internal storage for node_id
   * @protected
   */
  protected _node_id?: openehr_base.String;

  /**
   * Semantic id of this node, used to differentiate sibling nodes of the same type. Each node_id must be defined in the archetype ontology as a term code.
   */
  get node_id(): string | undefined {
    return this._node_id?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for node_id.
   * Use this to access openehr_base.String methods.
   */
  get $node_id(): openehr_base.String | undefined {
    return this._node_id;
  }

  /**
   * Sets node_id from either a primitive value or openehr_base.String wrapper.
   */
  set node_id(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._node_id = undefined;
    } else if (typeof val === "string") {
      this._node_id = openehr_base.String.from(val);
    } else {
      this._node_id = val;
    }
  }

  /**
   * Internal storage for is_deprecated
   * @protected
   */
  protected _is_deprecated?: openehr_base.Boolean;

  get is_deprecated(): boolean | undefined {
    return this._is_deprecated?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for is_deprecated.
   * Use this to access openehr_base.Boolean methods.
   */
  get $is_deprecated(): openehr_base.Boolean | undefined {
    return this._is_deprecated;
  }

  /**
   * Sets is_deprecated from either a primitive value or openehr_base.Boolean wrapper.
   */
  set is_deprecated(val: boolean | openehr_base.Boolean | undefined) {
    if (val === undefined || val === null) {
      this._is_deprecated = undefined;
    } else if (typeof val === "boolean") {
      this._is_deprecated = openehr_base.Boolean.from(val);
    } else {
      this._is_deprecated = val;
    }
  }

  specialisation_depth(): openehr_base.Integer {
    // TODO: Implement specialisation_depth behavior
    // This will be covered in Phase 3 (see ROADMAP.md)
    throw new Error("Method specialisation_depth not yet implemented.");
  }
}

/**
 * Abstract model of constraint on any kind of attribute node.
 */
export class P_C_ATTRIBUTE extends P_ARCHETYPE_CONSTRAINT {
  /**
   * Internal storage for rm_attribute_name
   * @protected
   */
  protected _rm_attribute_name?: openehr_base.String;

  /**
   * Reference model attribute within the enclosing type represented by a C_OBJECT.
   */
  get rm_attribute_name(): string | undefined {
    return this._rm_attribute_name?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for rm_attribute_name.
   * Use this to access openehr_base.String methods.
   */
  get $rm_attribute_name(): openehr_base.String | undefined {
    return this._rm_attribute_name;
  }

  /**
   * Sets rm_attribute_name from either a primitive value or openehr_base.String wrapper.
   */
  set rm_attribute_name(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._rm_attribute_name = undefined;
    } else if (typeof val === "string") {
      this._rm_attribute_name = openehr_base.String.from(val);
    } else {
      this._rm_attribute_name = val;
    }
  }

  /**
   * Internal storage for existence
   * @protected
   */
  protected _existence?: openehr_base.String;

  /**
   * Constraint on every attribute, regardless of whether it is singular or of a container type, which indicates whether its target object exists or not (i.e. is mandatory or not).
   */
  get existence(): string | undefined {
    return this._existence?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for existence.
   * Use this to access openehr_base.String methods.
   */
  get $existence(): openehr_base.String | undefined {
    return this._existence;
  }

  /**
   * Sets existence from either a primitive value or openehr_base.String wrapper.
   */
  set existence(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._existence = undefined;
    } else if (typeof val === "string") {
      this._existence = openehr_base.String.from(val);
    } else {
      this._existence = val;
    }
  }

  /**
   * Child C_OBJECT nodes. Each such node represents a constraint on the type of this attribute in its reference model. Multiples occur both for multiple items in the case of container attributes, and alternatives in the case of singular attributes.
   */
  children?: undefined;
  /**
   * Internal storage for differential_path
   * @protected
   */
  protected _differential_path?: openehr_base.String;

  /**
   * Within a differential specialised archetype, may be set to represent a deep path within the structure to which this constraint and its child constraints apply.
   */
  get differential_path(): string | undefined {
    return this._differential_path?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for differential_path.
   * Use this to access openehr_base.String methods.
   */
  get $differential_path(): openehr_base.String | undefined {
    return this._differential_path;
  }

  /**
   * Sets differential_path from either a primitive value or openehr_base.String wrapper.
   */
  set differential_path(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._differential_path = undefined;
    } else if (typeof val === "string") {
      this._differential_path = openehr_base.String.from(val);
    } else {
      this._differential_path = val;
    }
  }

  /**
   * Internal storage for cardinality
   * @protected
   */
  protected _cardinality?: openehr_base.String;

  /**
   * Cardinality constraint of attribute, if a container attribute.
   */
  get cardinality(): string | undefined {
    return this._cardinality?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for cardinality.
   * Use this to access openehr_base.String methods.
   */
  get $cardinality(): openehr_base.String | undefined {
    return this._cardinality;
  }

  /**
   * Sets cardinality from either a primitive value or openehr_base.String wrapper.
   */
  set cardinality(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._cardinality = undefined;
    } else if (typeof val === "string") {
      this._cardinality = openehr_base.String.from(val);
    } else {
      this._cardinality = val;
    }
  }

  /**
   * Internal storage for is_multiple
   * @protected
   */
  protected _is_multiple?: openehr_base.Boolean;

  /**
   * Flag indicating whether this attribute constraint is on a container (i.e. multiply-valued) attribute.
   */
  get is_multiple(): boolean | undefined {
    return this._is_multiple?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for is_multiple.
   * Use this to access openehr_base.Boolean methods.
   */
  get $is_multiple(): openehr_base.Boolean | undefined {
    return this._is_multiple;
  }

  /**
   * Sets is_multiple from either a primitive value or openehr_base.Boolean wrapper.
   */
  set is_multiple(val: boolean | openehr_base.Boolean | undefined) {
    if (val === undefined || val === null) {
      this._is_multiple = undefined;
    } else if (typeof val === "boolean") {
      this._is_multiple = openehr_base.Boolean.from(val);
    } else {
      this._is_multiple = val;
    }
  }
}

/**
 * Abstract parent type of C_OBJECT subtypes that are defined by value, i.e. whose definitions are actually in the archetype rather than being by reference.
 */
export abstract class P_C_DEFINED_OBJECT extends P_C_OBJECT {
  /**
   * Internal storage for is_frozen
   * @protected
   */
  protected _is_frozen?: openehr_base.Boolean;

  get is_frozen(): boolean | undefined {
    return this._is_frozen?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for is_frozen.
   * Use this to access openehr_base.Boolean methods.
   */
  get $is_frozen(): openehr_base.Boolean | undefined {
    return this._is_frozen;
  }

  /**
   * Sets is_frozen from either a primitive value or openehr_base.Boolean wrapper.
   */
  set is_frozen(val: boolean | openehr_base.Boolean | undefined) {
    if (val === undefined || val === null) {
      this._is_frozen = undefined;
    } else if (typeof val === "boolean") {
      this._is_frozen = openehr_base.Boolean.from(val);
    } else {
      this._is_frozen = val;
    }
  }

  default_value?: openehr_base.Any;
}

/**
 * A constraint defined by proxy, using a reference to an object constraint defined elsewhere in the same archetype. Note that since this object refers to another node, there are two objects with available occurrences values. The local occurrences value on a COJMPLEX_OBJECT_PROXY should always be used; when setting this from a seri- alised form, if no occurrences is mentioned, the target occurrences should be used (not the standard default of {1..1}); otherwise the locally specified occurrences should be used as normal. When serialising out, if the occurrences is the same as that of the target, it can be left out.
 */
export class P_C_COMPLEX_OBJECT_PROXY extends P_C_OBJECT {
  /**
   * Internal storage for target_path
   * @protected
   */
  protected _target_path?: openehr_base.String;

  /**
   * Reference to an object node using archetype path notation.
   */
  get target_path(): string | undefined {
    return this._target_path?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for target_path.
   * Use this to access openehr_base.String methods.
   */
  get $target_path(): openehr_base.String | undefined {
    return this._target_path;
  }

  /**
   * Sets target_path from either a primitive value or openehr_base.String wrapper.
   */
  set target_path(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._target_path = undefined;
    } else if (typeof val === "string") {
      this._target_path = openehr_base.String.from(val);
    } else {
      this._target_path = val;
    }
  }
}

/**
 * Constraint describing a  slot' where another archetype can occur.
 */
export class P_ARCHETYPE_SLOT extends P_C_OBJECT {
  /**
   * List of constraints defining other archetypes that could be included at this point.
   */
  includes?: undefined;
  /**
   * List of constraints defining other archetypes that cannot be included at this point.
   */
  excludes?: undefined;
  /**
   * Internal storage for is_closed
   * @protected
   */
  protected _is_closed?: openehr_base.Boolean;

  get is_closed(): boolean | undefined {
    return this._is_closed?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for is_closed.
   * Use this to access openehr_base.Boolean methods.
   */
  get $is_closed(): openehr_base.Boolean | undefined {
    return this._is_closed;
  }

  /**
   * Sets is_closed from either a primitive value or openehr_base.Boolean wrapper.
   */
  set is_closed(val: boolean | openehr_base.Boolean | undefined) {
    if (val === undefined || val === null) {
      this._is_closed = undefined;
    } else if (typeof val === "boolean") {
      this._is_closed = openehr_base.Boolean.from(val);
    } else {
      this._is_closed = val;
    }
  }
}

/**
 * Parent of types representing constraints on primitive types.
 */
export abstract class P_C_PRIMITIVE_OBJECT extends P_C_DEFINED_OBJECT {
  /**
   * Value to be assumed if none sent in data.
   */
  assumed_value?: openehr_base.Any;
  /**
   * Internal storage for is_enumerated_type_constraint
   * @protected
   */
  protected _is_enumerated_type_constraint?: openehr_base.Boolean;

  /**
   * True if this constraint is actually of an enumerated type that conforms to a primitive type, not a primitive.
   */
  get is_enumerated_type_constraint(): boolean | undefined {
    return this._is_enumerated_type_constraint?.value;
  }

  /**
   * Gets the openehr_base.Boolean wrapper object for is_enumerated_type_constraint.
   * Use this to access openehr_base.Boolean methods.
   */
  get $is_enumerated_type_constraint(): openehr_base.Boolean | undefined {
    return this._is_enumerated_type_constraint;
  }

  /**
   * Sets is_enumerated_type_constraint from either a primitive value or openehr_base.Boolean wrapper.
   */
  set is_enumerated_type_constraint(
    val: boolean | openehr_base.Boolean | undefined,
  ) {
    if (val === undefined || val === null) {
      this._is_enumerated_type_constraint = undefined;
    } else if (typeof val === "boolean") {
      this._is_enumerated_type_constraint = openehr_base.Boolean.from(val);
    } else {
      this._is_enumerated_type_constraint = val;
    }
  }

  /**
   * Constraint represented by this object; redefine in descendants.
   */
  constraint?: openehr_base.Any;
}

/**
 * Constraint on complex objects, i.e. any object that consists of other object constraints.
 */
export class P_C_COMPLEX_OBJECT extends P_C_DEFINED_OBJECT {
  /**
   * List of constraints on attributes of the reference model type represented by this object.
   */
  attributes?: undefined;
  /**
   * List of attribute tuple constraints under this object constraint, if any.
   */
  attribute_tuples?: undefined;
}

/**
 * Object representing a constraint on an atttribute tuple, i.e. a group of attributes that are constrained together. Typically used for representing co-varying constraints like {units, range} constraints.
 */
export class P_C_ATTRIBUTE_TUPLE {
  /**
   * Member attribute constraint objects.
   */
  members?: undefined;
}

export class P_C_ARCHETYPE_ROOT extends P_C_COMPLEX_OBJECT {
  /**
   * Internal storage for archetype_ref
   * @protected
   */
  protected _archetype_ref?: openehr_base.String;

  get archetype_ref(): string | undefined {
    return this._archetype_ref?.value;
  }

  /**
   * Gets the openehr_base.String wrapper object for archetype_ref.
   * Use this to access openehr_base.String methods.
   */
  get $archetype_ref(): openehr_base.String | undefined {
    return this._archetype_ref;
  }

  /**
   * Sets archetype_ref from either a primitive value or openehr_base.String wrapper.
   */
  set archetype_ref(val: string | openehr_base.String | undefined) {
    if (val === undefined || val === null) {
      this._archetype_ref = undefined;
    } else if (typeof val === "string") {
      this._archetype_ref = openehr_base.String.from(val);
    } else {
      this._archetype_ref = val;
    }
  }
}
